import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
    <Loader2 className="w-8 h-8 animate-spin text-moss" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  // If we already have a user (cached or fresh), render immediately —
  // background revalidation will redirect later if the session is truly invalid.
  if (user && typeof user === "object") return children;
  if (loading) return <Spinner />;
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export const ProfileRequiredRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (user && typeof user === "object") {
    if (!user.has_health_profile && user.role !== "admin") {
      return <Navigate to="/health-profile" replace />;
    }
    return children;
  }
  if (loading) return <Spinner />;
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (user && typeof user === "object") {
    if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
  }
  if (loading) return <Spinner />;
  return <Navigate to="/admin/login" replace />;
};
